import { setAudit } from "@/stores/features/auditSlice";
import { useAppDispatch } from "@/stores/hooks";
import { auditService } from "@/stores/services/auditService";
import { decryptId } from "@/utils/utilsMethods";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

export function useAuditData() {
  const dispatch = useAppDispatch();
  const { idCompany } = useParams();
  const [searchParams] = useSearchParams();

  const auditParam = searchParams.get("audit");
  const auditId = auditParam
    ? parseInt(decryptId(auditParam))
    : undefined;
  const companyId = parseInt(decryptId(idCompany ?? ""));

  const { data: auditData } = auditService.useFindByIdQuery(
    auditId ? { auditId } : skipToken
  );

  useEffect(() => {
    if (auditData) {
      dispatch(setAudit(auditData.audit));
    }
  }, [auditData, dispatch]);

  return {
    auditData,
    companyId,
    auditId,
  };
}
